import { styled } from "@vw-marketing/us-components";

export const StyledTosWrapper: any = styled.div`
  width: 100%;
`;

export const StyledLegalContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static300};
  padding-top: ${({ theme }) => theme.size.static250};
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 8px;
`;

export const StyledCheckBoxContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static300};
`;

export const StyledSubmitButtonContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static350};
`;

export const StyledDeclineButtonContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static300};
  text-align: center;
`;